import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import SpecialCard from '../../SpecialCard';
import SpecialCardSingle from '../../SpecialCardSingle';
import PageSectionHeading from '../../PageSectionHeading';
import { colors, typography } from '../../../styles';

const styles = css`
  margin: 30px 0;
  padding: 45px 0;
  background-color: ${colors.brand1};
  background-image: url('/images/pattern-03-dark.svg');
  @media(min-width: 768px) {
    margin: 0 0 0 0;
    padding: 90px 0 120px 0;
  }
  .SpecialOffersHeading {
    font-family: ${typography.Serif};
    color: ${colors.brand1};
    margin: 0 0 30px 0;
    font-weight: 700;
    font-size: 32px;
    text-transform: uppercase;
    text-align: center;
    @media (min-width: 992px) {
      font-size: 44px;
      margin: 0 0 60px 0;
    }
  }
`;

function SpecialOffers({ page }) {
  const publishedSpecials = get(page, 'special', []).filter(item => item.published);
  return (
    <div>
      {
        publishedSpecials.length > 0 &&
        <div className={styles}>
          {
            publishedSpecials.length > 1 &&
            <div className="container-fluid Special_list">
              <PageSectionHeading h3="Current Specials" className="text-white" />
              <div className="d-flex flex-wrap justify-content-center">
                {
                  publishedSpecials.map(item => (
                    <SpecialCard special={item} key={item._id} />
                  ))
                }
              </div>
            </div>
          }
          {
            publishedSpecials.length === 1 &&
            <div>
              <PageSectionHeading h3="Current Special" className="text-white" />
              <div>
                {
                  publishedSpecials.map(item => (
                    <SpecialCardSingle special={item} key={item._id} />
                  ))
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  );
}

SpecialOffers.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'special_offers',
})(SpecialOffers);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/SpecialOffers.section.js